import { z } from "zod";
import { UuidSchema } from "./common.js";
/** Classements (/api/leaderboards/:metric). */
export const LEADERBOARD_METRICS = [
    "niveau",
    "argent",
    "kills",
    "morts",
    "streak",
    "playtime",
    "jobs",
    "donjons",
    "votes",
];
export const LeaderboardMetricSchema = z.enum(LEADERBOARD_METRICS);
/** Libellés FR d'onglet. */
export const LEADERBOARD_LABEL_FR = {
    niveau: "Niveau",
    argent: "Fortune",
    kills: "Kills",
    morts: "Morts",
    streak: "Série PvP",
    playtime: "Temps de jeu",
    jobs: "Métiers",
    donjons: "Donjons",
    votes: "Votes du mois",
};
/** Sous-titre FR par métrique (affiché sous le classement). */
export const LEADERBOARD_TAGLINE_FR = {
    niveau: "L'expérience réseau cumulée — les âmes les plus aguerries d'Etheria.",
    argent: "Les coffres les mieux garnis du royaume, pièce par pièce.",
    kills: "Les lames les plus redoutées des champs de bataille.",
    morts: "Le mémorial des braves — tombés, mais jamais oubliés.",
    streak: "Les plus longues séries de victoires sans connaître la défaite.",
    playtime: "Les veilleurs infatigables, heure après heure passée en Etheria.",
    jobs: "Les artisans les plus assidus, toutes vocations confondues.",
    donjons: "Les conquérants de cryptes — expéditions menées à leur terme.",
    votes: "Les hérauts du royaume — soutiens du serveur ce mois-ci.",
};
export const LeaderboardEntrySchema = z.object({
    rank: z.number().int().positive(),
    uuid: UuidSchema,
    name: z.string().nullable(),
    /** valeur brute (nombre). Pour "argent" c'est balance_sort, l'affichage exact vient à part. */
    value: z.number(),
    /** valeur d'affichage formatée FR (ex "1 234 567 pièces", "12j 4h"). */
    display: z.string(),
    /** secondaire (ex métier dominant, classe). */
    meta: z.string().nullable().optional(),
});
export const LeaderboardResSchema = z.object({
    metric: LeaderboardMetricSchema,
    entries: z.array(LeaderboardEntrySchema),
    total: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
//# sourceMappingURL=leaderboard.js.map